import { render } from "./FontEditor.vue?vue&type=template&id=cd3f0c48&scoped=true&ts=true"
import script from "./FontEditor.vue?vue&type=script&lang=ts"
export * from "./FontEditor.vue?vue&type=script&lang=ts"

import "./FontEditor.vue?vue&type=style&index=0&id=cd3f0c48&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3f0c48"]])

export default __exports__